$(function () {
    convertCmToInches();

    function convertCmToInches() {
        let cm = 0;
        $(".table td").each(function() {
            cm = parseFloat($(this).find(".cm").html()) / 2.54;
            $(this).find(".inches").html(cm.toFixed(1));
        });
    }
    
    $(".form-check-input[name='unitExchange']").on("click", function(){
        if ($("#cmUnit").is(":checked")) {
            $("td .cm").show();
            $("td .inches").hide();
            $(".unit-name").text("cm");
        }
        else {
            $("td .cm").hide();
            $("td .inches").show();
            $(".unit-name").text("inches");
        }
    });

    $(".size-button").on("click", function(){
        let target = $(this).data("target");

        $(".size-button").removeClass("active");
        $(this).addClass("active");

        $("tbody td").removeClass("table-active");
        $("tbody td[data-target='" + target +"']").addClass("table-active");

        $(".measure-left div[data-target]").hide();
        $(".measure-left div[data-target='" + target +"']").show();
        
        $(".measure-right svg path").removeClass("active");
        $(".measure-right svg path[data-target='" + target +"']").addClass("active");
    });
});